import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchComments } from '@/actions/comment';
import ShoppingCommentTimeline from '@/components/shoppings/ShoppingCommentTimeline';
import useCommentList from '@/hooks/useCommentList';
import { IShopping } from '@/@types/generated/contentful';

type ComponentProps = {
  shopping: IShopping;
};

const ShoppingCommentTimelineContainer: React.FC<ComponentProps> = ({ shopping }) => {
  const dispatch = useDispatch();
  const { id } = shopping.fields;
  const commentList = useCommentList();
  useEffect(() => {
    dispatch(fetchComments(id));
  }, [dispatch, id]);
  return <ShoppingCommentTimeline commentList={commentList} shoppingId={id} />;
};

export default ShoppingCommentTimelineContainer;
